export const SET_SELECTED_TICKET = 'SET_SELECTED_TICKET';
export const RESET_SELECTED_TICKET = 'RESET_SELECTED_TICKET';
export const SET_SELECTED_QUANTITY = "SET_SELECTED_QUANTITY";